export type Environment = 'dev' | 'stg' | 'prod';

export type FeatureFlagsConfig = Record<string, Environment | boolean>;

export enum FeatureFlags {
  RESEND_INVITATION_EMAIL = 'RESEND_INVITATION_EMAIL',
  NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
}
